module.exports = __webpack_public_path__ + "media/images/icons/email-light-8b4a076703c546e31a4a13ee90d72147.png";